<div class="card card-custom">
  <div class="card-header">
    <h3 class="m-0">
      {{
        (!!data?.relatedTemplates?.length ? 'TASK.CREATE_RELATED_TASK' : 'TASK.CREATE_TASK')
          | translate
      }}
    </h3>
  </div>
  <div class="card-body">
    <mat-form-field appearance="standard" class="w-100 mb-15px">
      <mat-label>Select an Option</mat-label>
      <mat-select [(value)]="fromTemplate" [disabled]="!!data?.relatedTemplates?.length">
        <mat-option [value]="false">Create without Template</mat-option>
        <mat-option [value]="true">Choose a Template</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="!!data?.relatedTemplates?.length" appearance="standard" class="w-100">
      <mat-label>{{ 'TASK.RELATED_TEMPLATE' | translate }}</mat-label>
      <mat-select [formControl]="templateCtrl" required>
        <mat-option *ngFor="let template of data.relatedTemplates" [value]="template">{{
          template.name
        }}</mat-option>
      </mat-select>
      <mat-error *ngIf="templateCtrl?.hasError('required')">{{
        'TASK.VALIDATION.REQUIRED' | translate : { label: 'TASK.RELATED_TEMPLATE' | translate }
      }}</mat-error>
    </mat-form-field>
    <ng-container *ngIf="fromTemplate && !data?.relatedTemplates?.length">
      <div *ngIf="!data?.fromNote" class="w-100 mb-15px">
        <kt-general-autocomplete
          #categoryAutocomplete
          [label]="'Team/Category'"
          [appearance]="'standard'"
          [dataPath]="'data'"
          [loadItemsFunction]="getCategoryAutocomplete$"
          [optionFormatter]="formatCategoryOption"
          [valueFormatter]="formatCategoryOption"
          [required]="true"
          [change]="handleCategoryChange.bind(this)"
        ></kt-general-autocomplete>
      </div>
      <div *ngIf="categoryAutocomplete?.value?.id" class="w-100">
        <kt-general-autocomplete
          #templateAutocomplete
          [label]="'Template'"
          [appearance]="'standard'"
          [dataPath]="'data'"
          [loadItemsFunction]="getTemplateAutocomplete$"
          [optionFormatter]="formatTemplateOption"
          [valueFormatter]="formatTemplateOption"
          [required]="true"
        ></kt-general-autocomplete>
      </div>
    </ng-container>
  </div>
  <div class="card-footer">
    <button
      mat-raised-button
      type="button"
      [disabled]="submitted"
      class="btn btn-sm btn-light"
      (click)="close($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      type="button"
      [disabled]="submitted"
      class="btn btn-sm btn-primary ml-15px"
      (click)="submit($event)"
    >
      <ng-container *ngIf="!submitted"> {{ 'GLOBAL.SUBMIT' | translate }} </ng-container>
      <ng-container *ngIf="submitted">
        <span class="spinner-border spinner-border-sm"></span>
        {{ 'GLOBAL.SUBMITTING' | translate }}
      </ng-container>
    </button>
  </div>
</div>
